import React from 'react';

export const ChevronUpIcon = props => {
  return (
    <span
      className="solstice-icon- solstice-icon-chevron-up"
      style={props.style || { color: '#757575', transform: 'scale(0.7)' }}
    />
  );
};
